import { useState, useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { Smartphone as DeviceIcon } from 'lucide-react'
import { useOnboarding } from './OnboardingFlow'
import { polling } from '../../lib/polling'
import { api } from '../../lib/api'

export default function AddDeviceStep() {
  const navigate = useNavigate()
  const { nextStep, validationError } = useOnboarding()
  const [hasDevices, setHasDevices] = useState(false)
  const [checkingDevices, setCheckingDevices] = useState(true)

  useEffect(() => {
    const checkDevices = async () => {
      try {
        const prerequisites = await api.getOnboardingPrerequisites()
        setHasDevices(prerequisites.hasDevices)
      } catch {
        setHasDevices(false)
      } finally {
        setCheckingDevices(false)
      }
    }

    checkDevices()

    const interval = setInterval(checkDevices, polling.onboardingCheck)
    return () => clearInterval(interval)
  }, [])

  const handleAddDevice = () => {
    navigate({ to: '/devices', search: { add: true } })
  }

  const handleContinue = async () => {
    await nextStep()
  }

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12">
      <div className="text-center mb-8">
        <div className="w-20 h-20 rounded-2xl bg-brand-light flex items-center justify-center mx-auto mb-6">
          <DeviceIcon size={64} className="text-brand" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Add Your First Device</h2>
        <p className="text-gray-600 max-w-md mx-auto">
          Connect an iPhone to start protecting it with Unbreakable.
        </p>
      </div>

      {validationError && (
        <div className="mb-6 bg-red-50 border border-red-200 rounded-xl p-4">
          <p className="text-sm text-red-700 text-center">{validationError}</p>
        </div>
      )}

      {!checkingDevices && hasDevices && (
        <div className="mb-6 bg-green-50 border border-green-200 rounded-xl p-4">
          <p className="text-sm text-green-800 text-center">
            Great! You have a device. Click continue to proceed.
          </p>
        </div>
      )}

      <div className="space-y-3">
        <button
          onClick={handleAddDevice}
          className="w-full py-3 bg-brand text-white rounded-xl font-medium hover:bg-brand-hover transition-colors"
        >
          Add Device Now
        </button>

        {hasDevices && (
          <button
            onClick={handleContinue}
            className="w-full py-3 bg-gray-100 text-gray-700 rounded-xl font-medium hover:bg-gray-200 transition-colors"
          >
            Continue
          </button>
        )}
      </div>
    </div>
  )
}
